import { MRT_ColumnDef} from "material-react-table";
import {
  CustomSearch,
  SingleTableBoxScene,
  SwitchComponente,
} from "@/shared/components/ui";
import { useCheckPermissions, useTableFilter } from "@/shared/hooks";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import { useMemo} from "react";
import { Mantenimiento } from "@/shared/interfaces";
import { useFetchMantenimiento, useUpdateMantenimiento } from "@/shared/actions/erp/activos";
import { useNavigate } from "react-router-dom";
import { useUiConfirmModalStore } from "@/store/ui";
import { hasAllPermissions, hasPermission } from "@/shared";
import { PermissionsEnum } from "@/auth/interfaces";

const returnUrlMantenimiento = '/activos/mantenimiento';

export interface MantenimientoPageInterface {}

const MantenimientoPage: React.FC<MantenimientoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_mantenimientoactivo)

  const navigate = useNavigate();

/*   const updateMantenimiento= useUpdateMantenimiento(navigate,returnUrl)
 */  const onEdit = (original: Mantenimiento) => {
    navigate(`${returnUrlMantenimiento}/editar/${original.id_mantenimiento_activo}`);
  };

    ///* global state
    const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
    const setConfirmDialogIsOpen = useUiConfirmModalStore(
      s => s.setConfirmDialogIsOpen
    );
    const  updateMantenimientoMutation = useUpdateMantenimiento({
      navigate,
      returnUrl:returnUrlMantenimiento,
    }
    )
  
  const columns = useMemo<MRT_ColumnDef<Mantenimiento>[]>(
    () => [
      {
        accessorKey: "codigo",
        header: "codigo",
        size: 200,
      },
      {
        accessorKey: "numero_referencia",
        header: "numero referencia",
        size: 200,
      },
      {
        accessorKey: "fecha_inicio",
        header: "fecha inicio",
        size: 200,
      },
      {
        accessorKey: "fecha_fin",
        header: "fecha fin",
        size: 200,
      },
      {
        accessorKey: "activo_data.nombre",
        header: "Nombre del activo",
        size: 200,
      },
      {
        accessorKey: "costo",
        header: "costo",
        size: 200,
      },
      {
        accessorKey: "encargado_data.razon_social",
        header: "encargado",
        size: 200,
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={row.original.estado}
            titulo={row.original.estado ? 'Activo' : 'Inactivo'}
            setEstadoSwitch={mantenimiento => {
              if (!hasPermission(PermissionsEnum.api_change_mantenimientoactivo)) return;
              setConfirmDialog({
                isOpen: true,
                title: 'Cambiar Estado',
                subtitle:
                  '¿Está seguro que desea cambiar el estado de este registro ?',
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  updateMantenimientoMutation.mutate({
                    id: row.original.id_mantenimiento_activo!,
                    data: {
                      ...row.original,
                      estado: mantenimiento as boolean,
                    },
                  });
                },
              });
            }}
          />
        ),
      },
    ],
    []
  );

  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter
  } = useTableFilter();


  const {
    isLoading,
    data: MantenimientoRes,
    isRefetching,
  } = useFetchMantenimiento({
    codigo: searchTerm,
    
  });

  return (
<>
<SingleTableBoxScene title="Mantenimiento" urlRedirect={`${returnUrlMantenimiento}/crear`} enableRedirect={hasPermission(PermissionsEnum.api_add_mantenimientoactivo)}>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} cleanFilter={cleanFilter} text="Mantenimiento" />
        <GeneralTable<Mantenimiento>
          columns={columns}
          data={MantenimientoRes?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={MantenimientoRes?.data?.count}
          enableColumnActions={hasAllPermissions([
            PermissionsEnum.api_change_mantenimientoactivo,
          ])}
          // // actions
          onEdit={onEdit}
          canEdit={hasAllPermissions([
            PermissionsEnum.api_change_mantenimientoactivo,
          ])}
          canDelete={false}
        />
        </SingleTableBoxScene>
   </>
  );
}

export default MantenimientoPage;